<template>
  <v-container grid-list-xl style="overflow-x: hidden; overflow-y: auto">
    <div>
      <!-- Sección de modals -->
      <v-snackbar
        v-model="getRequestResult.showMessage"
        :color="getRequestResult.statusColor"
        dark
        :timeout="2500"
      >
        Perfil Actualizado
        <v-btn color="white" text @click="initRequestResult">Cerrar</v-btn>
      </v-snackbar>
      <v-snackbar v-model="getError.error" color="error" :timeout="3500">{{
        getError.errorMessage
      }}</v-snackbar>
    </div>
    <content-perfil :user-data="userData"></content-perfil>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    ContentPerfil: () => import('@/components/user/profile/ContentPerfil.vue'),
  },
  props: ['userData'],
  data: () => ({
    snackbar: false,
    snackbarStatus: '',
    snackbarText: '',
  }),
  methods: {
    ...mapMutations('user', ['initRequestResult']),
  },
  computed: {
    ...mapGetters('user', ['getError', 'getRequestResult']),
  },
}
</script>
